<template>
  <CMainPage></CMainPage>
</template>

<script>
import CMainPage from "@/CMainPage.vue";
export default {
  name: "App",
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  components: {
    CMainPage
  }
}
</script>

<style lang="scss">
@import "~bootstrap/dist/css/bootstrap.css";
@import "@/lib/tui/scss/app.scss";

.navbar-nav {
  flex-direction: row;
}

.navbar {
  padding: 0.5vh 0.5vw;
}
// #app {
//   font-family: Avenir, Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
//   background: grey;
// }

// nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
</style>
